<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24"> </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator-button">
      <a-button
        @click="handleEditClick"
        type="primary"
        v-if="projectRecords[0].manager == userInfo.username"
        icon="edit"
        >{{ isEditStatus ? '退出编辑' : '进入编辑' }}</a-button
      >
      <a-button @click="handleEditClick" type="primary" v-else v-has="'DailyProject:admin'" icon="edit">{{
        isEditStatus ? '退出编辑' : '进入编辑'
      }}</a-button>
      <a-button v-if="isEditStatus === true" @click="handleSaveClick" type="primary" icon="save">保存</a-button>
      <a-button v-if="isEditStatus === true" @click="handleAddClick" type="primary" icon="plus">新增</a-button>
      <a-button v-if="isEditStatus === true && selectedRowKeys.length > 0" @click="handleDeleteClick" icon="delete"
        >删除</a-button
      >
      <a-button
        style="margin-left: auto"
        v-if="isEditStatus === false"
        type="primary"
        @click="searchQuery"
        icon="search"
        >查询</a-button
      >
    </div>
    <a-alert class="margin-top-20px" v-if="isEditStatus === true" :message="infoMessage" type="info" show-icon />
    <div class="margin-top-20px">
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="false"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <div slot="membersId" slot-scope="text, record">
          <span>{{ record.members }}</span>
        </div>
        <div slot="membersId" slot-scope="text, record">
          <a-input
            class="edit-table-input"
            v-if="isEditStatus"
            :value="record.members"
            readonly
            @click="handleUserNameClick(record)"
            @input="$set(record, 'isEdit', true)"
          ></a-input>
          <span v-else>{{ record.members }}</span>
        </div>
        <div slot="subordinateRole" slot-scope="text, record">
          <j-dict-select-tag
            class="edit-table-input"
            :disabled="!isEditStatus"
            v-model="record.subordinateRole"
            dictCode="project_daily_role"
            @input="$set(record, 'isEdit', true)"
          ></j-dict-select-tag>
        </div>
        <div slot="workload" slot-scope="text, record">
          <a-input-number
            :min="1"
            :max="100"
            v-model="record.workload"
            :readonly="!isEditStatus"
            @change="$set(record, 'isEdit', true)"
          ></a-input-number>
        </div>
        <div class="edit-dot-td" slot="isEdit" slot-scope="text">
          <div class="edit-dot" :class="{ 'isedit-status-red': text, 'isedit-status-gree': !text }"></div>
        </div>
      </a-table>
    </div>
    <select-user-modal
      :isNotAddStarSign="true"
      ref="selectUserModal"
      @selectedOne="handleUserSelect"
      listUrl="/dailyproject/busDailyProjectUser/selectAllMember"
      only-select-one
    ></select-user-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import SelectUserModal from '@/components/common/SelectUserModal.vue'
import { batchAddDailyProjectUserNext } from '@/api/api.js'
import { USER_INFO } from '@/store/mutation-types'
import Vue from 'vue'
const columnsDefault = [
  {
    title: '#',
    dataIndex: '',
    key: 'rowIndex',
    width: '20%',
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '姓名',
    align: 'center',
    dataIndex: 'membersId',
    scopedSlots: { customRender: 'membersId' },
    width: '25%',
  },
  {
    title: '角色',
    align: 'center',
    dataIndex: 'subordinateRole',
    scopedSlots: { customRender: 'subordinateRole' },
    width: '25%',
  },
  {
    title: '工作量占比',
    align: 'center',
    dataIndex: 'workload',
    scopedSlots: { customRender: 'workload' },
    width: '25%',
  },
]
export default {
  name: 'BusDailyProjectUserList',
  mixins: [JeecgListMixin],
  components: {
    SelectUserModal,
  },
  mounted() {
    this.$nextTick(() => {
      this.userInfo = Vue.ls.get(USER_INFO)
    })
  },
  props: {
    projectRecords: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      description: '项目人员表管理页面',
      // 表头
      columns: columnsDefault,
      url: {
        list: '/dailyproject/busDailyProjectUser/selectProjectMember',
        delete: '/dailyproject/busDailyProjectUser/delete',
        deleteBatch: '/dailyproject/busDailyProjectUser/deleteBatch',
        exportXlsUrl: '/dailyproject/busDailyProjectUser/exportXls',
        importExcelUrl: 'dailyproject/busDailyProjectUser/importExcel',
      },
      dictOptions: {},
      disableMixinCreated: true,
      isEditStatus: false,
      usernameChooseRecord: {},
      infoMessage: '修改后需等到次日凌晨才能生效',
      userInfo: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initData() {
      this.loadData()
    },
    loadData() {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (!this.projectRecords[0].id) {
        this.$message.error('projectRecords没有传值')
        return
      }
      this.loading = true
      this.dataSource = []
      getAction(this.url.list, { projectId: this.projectRecords[0].id }).then((res) => {
        if (res.success) {
          this.dataSource = res.result
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
      this.isEditStatus = false
    },
    handleEditClick() {
      if (this.isEditStatus) {
        if (this.dataSource.length === 0) {
          this.isEditStatus = !this.isEditStatus
          return
        }
        let isEdited = this.dataSource.some((item) => {
          return item.isEdit
        })
        if (isEdited) {
          this.$antdConfirm({
            title: '取消编辑',
            content: '您尚未保存内容，退出会丢失全部，是否确定？',
            onOk: () => {
              this.isEditStatus = !this.isEditStatus
              this.loadData(1)
            },
          })
        } else {
          this.isEditStatus = !this.isEditStatus
        }
      } else {
        this.isEditStatus = !this.isEditStatus
      }
    },
    handleSaveClick() {
      let totalScro = this.dataSource.reduce((total, item) => {
        return total + item.workload
      }, 0)
      if (totalScro != 100) {
        this.$antdConfirm({
          title: '提交数据有误',
          content: `工作量占比之和必须刚好为100%`,
          onOk() {},
        })
        return
      }
      let isEdit = this.dataSource.some((item) => {
        return item.isEdit ? item.isEdit : false
      })
      if (isEdit) {
        let errorList = []
        errorList = this.dataSource.filter((item, index) => {
          if (!item.membersId || !item.subordinateRole || !item.workload) {
            item.index = index + 1
            return true
          }
          return false
        })
        if (errorList.length > 0) {
          this.$antdConfirm({
            title: '提交数据有误',
            content: `第${errorList[0].index}行数据有误，姓名角色不得为空，工作占比不得为0！`,
            onOk() {},
            class: 'test',
          })
          return
        }
        if (!this.projectRecords[0].id) {
          this.$message.error('找不到项目，请重新选择项目！')
          return
        }
        let dataSourceNew = this.dataSource.map((item) => {
          return {
            projectId: this.projectRecords[0].id,
            ...item,
          }
        })
        this.$antdConfirm({
          title: '保存',
          content: '是否讲修改的内容进行保存，请慎重操作！',
          onOk: () => {
            batchAddDailyProjectUserNext(dataSourceNew)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success('保存成功')
                  this.isEditStatus = !this.isEditStatus
                  this.loadData(1)
                  this.$emit('refresh')
                  if (res.result === '后续提交的日报') {
                    this.$emit('changeMenus', 'MEMBERS_NEXT')
                  }
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((err) => {
                if (err.message) {
                  this.$message.error(err.message)
                } else {
                  this.$message.error(err)
                }
              })
          },
        })
      } else {
        this.$message.info('没有改动，您无需进行保存！')
      }
    },
    handleAddClick() {
      this.dataSource.push({
        subordinateRole: '',
        workload: 0,
        membersId: '',
        isEdit: true,
      })
    },
    handleDeleteClick() {
      this.dataSource = this.dataSource.filter((item, index) => {
        for (const iterator of this.selectedRowKeys) {
          if (index == iterator || item.id == iterator) {
            return false
          }
        }
        return true
      })
      this.selectedRowKeys = []
      this.selectionRows = []
    },
    handleUserNameClick(record) {
      this.usernameChooseRecord = record
      this.$refs.selectUserModal.add()
    },
    handleUserSelect(record) {
      let isHave = this.dataSource.some((item) => {
        return item.membersId === record[0].username
      })
      if (isHave) {
        this.$message.error(record[0].realname + '已存在，请勿添加')
        return
      }
      this.$set(this.usernameChooseRecord, 'membersId', record[0].username)
      this.$set(this.usernameChooseRecord, 'members', record[0].realname)
      this.$set(this.usernameChooseRecord, 'isEdit', true)
    },
  },
  watch: {
    isEditStatus(newVal) {
      if (newVal) {
        this.columns = columnsDefault.concat()
        this.columns.push({
          title: '改动',
          align: 'center',
          dataIndex: 'isEdit',
          scopedSlots: { customRender: 'isEdit' },
        })
      } else {
        this.columns = columnsDefault.concat()
      }
    },
    projectRecords: {
      handler() {
        this.loadData(1)
      },
      immediate: true,
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.edit-dot-td {
  display: flex;
  justify-content: center;
  align-items: center;
  .edit-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
  .isedit-status-red {
    background-color: red !important;
  }
  .isedit-status-gree {
    background-color: green !important;
  }
}
.edit-table-input {
  width: 120px;
}
</style>
